export default {
  supportCollectCityList: [],
  collectCity: {},
  collectStore: {},
  collectInfo: { storeCode: '', cityCode: '' },
  collectSkuInfo: {}
}
